/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthService, NbAuthResult } from '@nebular/auth';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN, NUMBERS_PATTERN } from '../constants';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { OtpVerifyDialogComponent } from '../otp-verify-dialog/otp-verify-dialog.component';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { UserData } from '../../../@core/interfaces/common/users';

@Component({
  selector: 'ngx-request-password-page',
  styleUrls: ['./request-password.component.scss'],
  templateUrl: './request-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRequestPasswordComponent implements OnInit {
  @Input() tenantId: any;
  @Input() customerId: any;
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  redirectDelay: number = this.getConfigValue('forms.requestPassword.redirectDelay');
  showMessages: any = this.getConfigValue('forms.requestPassword.showMessages');
  strategy: string = this.getConfigValue('forms.requestPassword.strategy');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  protected readonly unsubscribe$ = new Subject<void>();
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  requestPasswordForm: FormGroup;
  isMobileNumberRequired: boolean = this.getConfigValue('forms.validation.mobileNumber.required');
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  isOtpDia: boolean =false;
  showmobileerrormsg: boolean =false;
  phoneNumber: any;
  OTPid:any;
  otpVerification:any;

    // To declare sms_dto to set values written by Abirami Paramasivam / 24.05.21
    smsdto={"variables":[],"template_id":"","to":"","service":"T"};
    branchName: string; 
    tenantUserId:any;
    get apiUrl(): string {
    return environment.apiUrl;
   }
    customerData : any;
    smscontent:string;
    validtime:string;
    smsotp:string;
    templateData:any;
    branchID:string;
    sendthroughsms:boolean=false;



  constructor(protected userService: UserData,public DatService:DateService,protected rolesService: RolesData,protected service: NbAuthService,protected tenantSrvc: TenantData,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected cd: ChangeDetectorRef,protected patRegSrvc: PatientRegistrationData,
              protected fb: FormBuilder,
              protected router: Router) { }

  get email() { return this.requestPasswordForm.get('email'); }
  get mobileNumber() { return this.requestPasswordForm.get('mobileNumber'); }

  ngOnInit(): void {
    console.log("customer Id in request pwd...",this.customerId);
    console.log("tenant Id in request pwd...",this.tenantId);
    const passwordValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && passwordValidators.push(Validators.required);
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    this.isMobileNumberRequired && mobileNumberValidators.push(Validators.required);
    this.requestPasswordForm = this.fb.group({
    mobileNumber: this.fb.control('', [...mobileNumberValidators]),
    tenantId: this.fb.control(''),
    });
  }

  backToLogIn()
  {
    this.diaClose.emit(null);
  }
  requestPass(): void {
    this.requestPasswordForm.controls["tenantId"].setValue(this.tenantId);

    this.errors = this.messages = [];
    this.submitted = true;
    this.user = this.requestPasswordForm.value;


    this.service.requestPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      console.log("request password success.......",result);
      if (result.isSuccess()) {
        this.messages = result.getMessages();
      //  this.sendOtp();
       this.sendsms();
      } else {
        this.errors = result.getErrors();
      }

      this.cd.detectChanges();
    });
  }
  sendOtp() {
    this.phoneNumber = this.requestPasswordForm.get('mobileNumber').value;
    this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + this.tenantId + '/sendotp/' + this.phoneNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      this.OTPid =  data;
    }, (error) => {
     

    }, () => {
      this.isOtpDia = true;
      this.cd.detectChanges();

      this.otpVerifyInstance.fromforgotPassword("forgotPassword")

    });

  }
  onOtpDiaClose(data: any): void {
    if (data == null)
      {
        this.isOtpDia = false;
        this.diaClose.emit(null);
      }
    else if (data.otpStatus == "approved" || data.otpStatus == "success") {
      this.isOtpDia = false
      this.diaClose.emit({otpVerified:data.otpStatus,resetMobileNum:this.phoneNumber})
     }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  verifyMobileIsexist()
  {
    this.errors = [];
    this.phoneNumber = this.requestPasswordForm.get('mobileNumber').value;
    if(!!this.phoneNumber && this.phoneNumber!=undefined){
    this.userService.getBranchList(`users/mobile/${this.phoneNumber}/${localStorage.getItem("responseTenantId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length>0){
        this.branchID=data[0].id;
        this.getotpsms();
        this.showmobileerrormsg=false;
      }
      else{
        this.showmobileerrormsg=true;
      }
      
    }, (error) => {

    }, () => {
     
    });
    }
  }

  getotpsms(){
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     this.OTPid=data;
      this.checksmspossibility();
    }, (error) => {
    }, () => {
    });
  }

  // To check sms send or not based on credit limit and template purchase based:-
  checksmspossibility(){
    let templateData;
    let istemplatepurchase;
    this.rolesService.list(`ezsTemplateMst/purchasedTemplateDetails/${this.tenantId}/${this.branchID}`).subscribe(data => {
      templateData=data;
      if(!!data){
        this.smscontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.OTPid + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
          istemplatepurchase = templateData.sms.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet?.smsTemplateNameMst?.templateName.toLocaleLowerCase() == "ezovion-otp")
          if(istemplatepurchase?.length>0){
            if(istemplatepurchase.length-1>-1){ 
              if(istemplatepurchase[istemplatepurchase.length-1]?.creditBalance > 0){
                this.sendthroughsms=true; 
                this.templateData=istemplatepurchase[istemplatepurchase.length-1];
                this.sendSMS(istemplatepurchase[istemplatepurchase.length-1]);
              }             
            }
            else{
              this.sendthroughsms=false; 
            }
          }
          else{
            this.sendthroughsms=false; 
          }
          this.isOtpDia = true;
          this.cd.detectChanges();
          this.otpVerifyInstance.fromforgotPassword("forgotPassword")
      }
    }, (error) => {
    }, () => {
    });
  }

  getJson(str: string): any {
    var strVal = str.replace(/\'/gi, '\"');
    return JSON.parse(strVal);
  }

  // To send sms for registration save and update:-
  sendSMS(templateData){
    let smstrackingDetails={
      referencefrom:"ezovion otp",
      referencenum:'0',
      mobileNumber:this.phoneNumber,
      dateTime:this.DatService.currentDate(),
      message:this.smscontent,
      smsUnit:1,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      status:"ok",
      templateId:templateData.commonTemplateMstDet.templateDetId,
      createdIp:null,
      createdby:parseInt(localStorage.getItem("userId")),
      createddate:this.DatService.currentDate(),
      tenantId:this.tenantId,
      branchId:this.branchID
    }
    
    let smsContent={
      text:this.smscontent,
      mobile:this.phoneNumber,
      apiURL:templateData.smsgatewaysettingsDet.providerUrl,
      apiKey:templateData.smsgatewaysettingsDet.providerKey,
      route:templateData.smsgatewaysettingsDet.serviceType,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      tenantId:this.tenantId,
      branchId:this.branchID,
      smstrackingDetails:smstrackingDetails,
      tenantApiConfigId:templateData?.tenantApiConfigId,
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendSMS`, smsContent).subscribe(data => {
    }, (error) => {
    }, () => {
    });
  }
  
  // To implement sms send function written by Abirami Paramasivam / 24.05.21
  sendsms(){
    this.tenantId ="E91B1784-7C0D-4A39-7E62-08D8F2BE6605";
    
    //https://localhost:44389/api/tenants/E91B1784-7C0D-4A39-7E62-08D8F2BE6605/tenantmst/phoneNum/9843561297
    // To set template variables and template id for to send sms using these template id written by Abirami Paramasivam / 24.05.21

    this.user = this.requestPasswordForm.value;

    this.tenantSrvc.getCustomerId(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst/phoneNum/${this.user.mobileNumber}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.customerData = data;
    }, (error) => {
    }, () => {

      this.smsdto.variables=[this.customerData.name,this.customerData.tenantUserId];
      this.smsdto.template_id = "d4c2ade9-a4bf-406c-8b84-9212342c2de3"; 
  
      // To call server side api for sms sending written by Abirami Paramasivam / 24.05.21
      this.patRegSrvc.sendgreetingsMessage("communication/" + this.tenantId + '/' + this.tenantId + '/send_greetings_message/' + this.user.mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
       }, (error) => {
       }, () => {
       });
    });
  }

}
